



















































































import { Component, Prop } from 'vue-property-decorator';
import { SwExtendedVue } from '@sonicwall/unified-ui-framework/src/shared/sw-extended-vue';
import UUIFComponent from '@/shared/uuifComponent';
import { DropdownLight } from '../../../../shared/dropdown-light';
import { required, helpers, sameAs } from 'vuelidate/lib/validators';
import RegexValidators from '@/shared/regex-validators';

const cssPrefix = 'mx-record-dialog';
const passwordPattern = helpers.regex('addressCheck', new RegExp(RegexValidators.passwordPattern));

@Component({
  components: {
    ...UUIFComponent,
    DropdownLight,
  },
  validations: {
    updateHESPasswordForm: {
      newPassword: { required, passwordPattern },
      confirmPassword: { sameAsPassword: sameAs('newPassword') },
      comment: { required },
    },
  },
})
export default class UpdateHesPasswordDialog extends SwExtendedVue {
  @Prop() showUpdateHesPasswordDialog: boolean;
  newPassword: string = '';
  confirmPassword: string = '';
  comments: string = '';
  cssPrefix = cssPrefix;
  notValid: boolean = false;
  doesnotMatch: boolean = false;
  submitted: boolean = false;
  updateHESPasswordForm: {
    newPassword: string,
    confirmPassword: string,
    comment: string,
  } = {
    newPassword: '',
    confirmPassword: '',
    comment: '',
  };

  created() {
  }

  validatePassword() {
    this.submitted = true;
    this.$v.$touch();
    if (!this.$v.$invalid) {
      const request = {
        newPassword: this.updateHESPasswordForm.newPassword,
        comment: this.updateHESPasswordForm.comment,
      };
      this.$emit('closeDialog', request);
    }
  }

  onSubmit() {
    this.validatePassword();
  }

  closeDialog() {
    this.$emit('closeDialog');
  }
}
